/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BackfillSyncEntitiesDisplayDateRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {BackfillSyncEntitiesDisplayDateResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const backfillSyncEntitiesDisplayDate = (request:BackfillSyncEntitiesDisplayDateRequest, options?: CashRequestOptions) => post<BackfillSyncEntitiesDisplayDateRequest, BackfillSyncEntitiesDisplayDateResponse>("/2.0/cash/backfill-sync-entities-display-date", request, {...options, rejectOnError: true })